module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div name=\"form-content\" class=\"wh100\">\n    <div name=\"map\" class=\"wh100\"></div>\n    <div class=\"gl-map-panel\" style=\"position: absolute; right: 5px; top: 5px;\" name=\"search-panel\">\n        <div>\n            <input type=\"text\" name=\"search\" placeholder=\"Поиск\" style=\"width: 400px;\">\n        </div>\n    </div>\n    <div name=\"menu\"></div>\n</div>\n")
  }
  return __output.join("");

}